<script>
    export let text = ""
</script>

<svelte:head>
    <title>pneuIN.sk | Mimo provoz.</title>
</svelte:head>

<div class="body">
    <section class="shutdown-g6c34s">
        <img src="assets/img/pneuin-cb-logo.png" alt="Logo PneuIN.sk">
        <h1>E-shop je momentálne nedostupný</h1>
        {@html text}
    </section>
</div>


<style>
    .body {
        height: 100vh;
        display: grid;
        place-items: center;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        overflow: hidden;
    }
    h1 {
        font-size: 1.5rem;
        margin-bottom: 1rem;
    }
    :global(.shutdown-g6c34s h3) {
        margin: 0.5rem;
    }
    section {
        text-align: center;
        display: flex;
        justify-content: center;
        place-items: center;
        flex-direction: column;
    }
    svg {
        width: 6rem;
        margin-bottom: 2rem;
    }
    img {
        width: 25rem;
        margin-bottom: 2rem;
    }
</style>